<template>
  <div class="date-selection-container">
    <slick ref="slick1" :options="dateSelectionSlider">
      <div v-for="(dateLoop, loop) in dates" :key="loop">
        <!-- new Date(dateLoop) > new Date(currentDate) ? 'pointer-none' : -->
        <div
          v-on:click="onSelecteDate(dateLoop)"
          :class="
            selectedDate == dateLoop
              ? 'active cursor-pointer'
              : allowPastBooking == 'Y'
              ? 'cursor-pointer'
              : new Date(currentDate) > new Date(dateLoop)
              ? 'cursor-pointer'
              : 'cursor-pointer'
          "
          class="date-slider-box"
        >
          <div class="text-center">
            <span>{{ dateLoop }}</span>
            <div class="lh-1" style="font-size:80%">
              {{ dateLoop | dayparse }}
            </div>
          </div>
        </div>
      </div>
    </slick>
  </div>
</template>

<script>
import Slick from "vue-slick";
import PosService from "@/services/PosService";
import $ from "jquery";
import moment from "moment";
import { EventBus } from "@/main";

export default {
  props: {
    childComponents: {
      type: Object
    },
    dateSelectionSlider: {
      type: Object,
      default: {
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: 1
      }
    },
    onChangeTab: {
      type: Function
    },
    selectedTabIndex: {
      type: Number,
      default: 0
    }
  },
  components: {
    Slick
  },
  data() {
    return {
      currentDate: "",
      cinema_id: ""
    };
  },
  beforeMount() {
    EventBus.$on("onSlickDateChange", data => {
      this.onChangeDate(data);
    });
  },
  mounted() {
    this.currentDate = moment().format("DD-MM-YYYY");
    this.cinema_id = this.secureStore.get("USINFO").cinema_id;
    // this.getAllDates();
  },
  watch: {
    selectedTabIndex(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$refs.slick1.destroy();
        this.$nextTick(() => {
          this.$refs.slick1.create();
          this.$refs.slick1.goTo(2, true);
        });
      }
    }
  },
  computed: {
    dates() {
      if (this.$refs && this.$refs.slick1) {
        this.$refs.slick1.destroy();
        this.$nextTick(() => {
          this.$refs.slick1.create();
          this.$refs.slick1.goTo(2, true);
        });
      }
      return this.$store.getters.DATES;
    },
    allowPastBooking() {
      return this.secureStore.get("BGOAPB") || "N";
    },
    selectedDate() {
      return this.$store.getters.SELECTED_DATE;
    },
    currentScreen() {
      return this.$store.getters.CURRENT_SCREEN;
    }
  },
  methods: {
    onChangeDate: function({ index }) {
      if (this.$refs && this.$refs.slick1) {
        this.$refs.slick1.destroy();
        this.$nextTick(() => {
          this.$refs.slick1.create();
          this.$refs.slick1.goTo(index, true);
        });
      }
    },
    onSelecteDate: function(date) {
      this.$store.dispatch("SET_CURRENT_SCREEN", null);
      if (
        this.childComponents &&
        (this.childComponents.PosSchedule ||
          this.childComponents.PosOccupancyStatus)
      ) {
        this.$store.dispatch("SET_DATE", date);
        this.$store.dispatch("GET_SEATS_OCCUPANCY", {
          selectedDate: date,
          screen_id: this.$store.getters.CURRENT_SCREEN || null,
          cinema_id: this.cinema_id
        });
      } else {
        this.$store.dispatch("SET_DATE", date);
      }
    }
    // onChangeTab: function() {
    //   console.log("this.$refs.slick1");
    //   this.$refs.slick1.destroy();
    //   this.$nextTick(() => {
    //     this.$refs.slick1.create();
    //     this.$refs.slick1.goTo(0, true);
    //   });
    // }
  }
};
</script>

<style>
.pointer-none {
  cursor: no-drop;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/posDateSlider.vue